import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import SectionRibbon from './SectionRibbon';
import EventCard from './EventCard';

const EventsSection = () => {
  const { t } = useLanguage();

  const events = [
    {
      title: 'Annual Legal Conference',
      description: 'Join us for the annual legal conference where leading experts will discuss current trends.',
      imageUrl: 'https://images.unsplash.com/photo-1589578527966-fdac0f44566c?w=395&h=258&fit=crop',
      details: {
        name: 'TANZANIA LAW WEEK 2024',
        date: '16 DECEMBER 2024',
        time: '09:00 AM - 04:00 PM',
        location: 'IJC DODOMA',
        fee: 'FREE'
      }
    },
    {
      title: 'Legal Aid Workshop',
      description: 'A workshop focused on providing legal aid services and improving access to justice.',
      imageUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=395&h=258&fit=crop',
      details: {
        name: 'LEGAL AID CLINIC',
        date: '20 DECEMBER 2024',
        time: '10:00 AM - 02:00 PM',
        location: 'DAR ES SALAAM',
        fee: 'FREE'
      }
    },
    {
      title: 'Judicial Training Seminar',
      description: 'Professional development seminar for judicial officers covering new technologies.',
      imageUrl: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=395&h=258&fit=crop',
      details: {
        name: 'DIGITAL COURTS SEMINAR',
        date: '10 JANUARY 2025',
        time: '09:00 AM - 05:00 PM',
        location: 'ARUSHA',
        fee: 'TZS 50,000'
      }
    },
    {
      title: 'Law Reform Forum',
      description: 'Open forum discussing proposed law reforms and their potential impact.',
      imageUrl: 'https://images.unsplash.com/photo-1589578527966-fdac0f44566c?w=395&h=258&fit=crop',
      details: {
        name: 'LAW REFORM DISCUSSION',
        date: '15 JANUARY 2025',
        time: '02:00 PM - 06:00 PM',
        location: 'MWANZA',
        fee: 'FREE'
      }
    }
  ];

  return (
    <div className="flex-1">
      <SectionRibbon title={t('events.title')} />
      <div className="flex flex-col items-center">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8 justify-items-center">
          {events.map((event, index) => (
            <EventCard
              key={index}
              index={index + 1}
              {...event}
            />
          ))}
        </div>
        <div className="mt-8 mb-4">
          <button 
            className="bg-[#0A1F87] text-white px-8 py-3 rounded-md hover:bg-[#0A1F87]/90 transition-colors duration-200 font-medium"
          >
            Explore our Events
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventsSection;